import React, { Component } from "react";

import "./App.scss";
import "./App.css";
import "./bootstrap4.css";
// After App.css: it carries the Bryntum theme these link styles override.
import "./components/Bryntum/Gantt/dependencyLinks.scss";

import { Provider } from "react-redux";
import store from "./store/store";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Logout from "./pages/user-management/Logout/Logout";
import SecuredRoute from "./securityUtils/SecuredRoute";

import { registerLicense } from "@syncfusion/ej2-base";
import TailSpinLoader from "./components/TailSpinLoader/TailSpinLoader";
import { toast } from "react-toastify";
import ConfettiComponent from "./components/Confetti/ConfettiShower";
import ForgotPasswordPage from "./pages/user-management/ForgotPasswordPage/ForgotPasswordPage";
import ResetPasswordPage from "./pages/user-management/ResetPasswordPage/ResetPasswordPage";
import Toaster from "./components/UI/Toaster/Toaster";
import ProgressNotificationStack from "./components/ProgressNotificationStack/ProgressNotificationStack";
import SsoCallback from "./pages/user-management/SsoCallback/SsoCallback";
import AutoLogoutWrapper from "./components/AutoLogoutWrapper/AutoLogoutWrapper";
import MfaVerificationPage from "./pages/user-management/MfaVerificationPage/MfaVerificationPage";
import MicrosoftLoginPage from "./pages/user-management/MicrosoftLoginPage/MicrosoftLoginPage";
import TenantSelectionPage from "./pages/user-management/TenantSelectionPage/TenantSelectionPage";

// Registering Syncfusion license key
registerLicense(
  "ORg4AjUWIQA/Gnt2VlhhQlJCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5UdEdiXXtZdHdTQmFZ"
);

const loading = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <TailSpinLoader />
    </div>
  );
};

const LoginPage = React.lazy(() =>
  import("./pages/user-management/LoginPage/LoginPage")
);
const LayoutPage = React.lazy(() => import("./pages/LayoutPage/LayoutPage"));

class App extends Component {

  componentDidMount() {
    window.addEventListener('online', () => toast.success('Connection was restored'));
    window.addEventListener('offline', () => toast.error('Connection was lost'));
  }

  render() {
    return (
      <Provider store={store}>
        <Router>
          <React.Suspense fallback={loading()}>
            <AutoLogoutWrapper>

              <Routes>
                <Route path="/login" name="Login Page" element={<LoginPage />} />
                <Route path="/forgot-password" name="Forgot Password Page" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" name="Set Password Page" element={<ResetPasswordPage />} />
                <Route path="/login/sso/callback" name="SSO Callback" element={<SsoCallback />} />
                <Route path="/mfa" name="MFA Validation Page" element={<MfaVerificationPage />} />
                <Route path="/select-tenant" name="Tenant Selection Page" element={<TenantSelectionPage />} />
                <Route path="/sso-login" element={<MicrosoftLoginPage />} />


                <Route exact path="/logout" element={<Logout />} />
                <Route
                  path="*"
                  name="Office"
                  element={
                    <SecuredRoute component={LayoutPage} />
                  }
                />
              </Routes>
            </AutoLogoutWrapper>

          </React.Suspense>
          <ConfettiComponent />
          <Toaster />
          <ProgressNotificationStack />
        </Router>
      </Provider>
    );
  }
}
export default App;
